import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SEO_META } from '../content/seoMeta.js';

/**
 * RouteSeo — per-route document head for public marketing pages.
 * Mounted ONCE in App.jsx. Looks up location.pathname in the SEO_META
 * registry and applies title / description / canonical / OG tags.
 * Paths not in the registry (the authenticated app) are untouched.
 *
 * No helmet dependency on purpose — a dozen public routes don't justify
 * one, and every dependency is a liability.
 */
const ORIGIN = 'https://markaii.com';
const OG_IMAGE = `${ORIGIN}/og-image.png`;

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function RouteSeo() {
  const { pathname } = useLocation();
  const path = pathname !== '/' && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  const meta = SEO_META[path];
  useEffect(() => {
    if (!meta) return;
    const url = `${ORIGIN}${path === '/' ? '/' : path}`;
    document.title = meta.title;
    setMeta('name', 'description', meta.description);
    setCanonical(url);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:title', meta.title);
    setMeta('property', 'og:description', meta.description);
    setMeta('property', 'og:image', OG_IMAGE);
    setMeta('name', 'twitter:title', meta.title);
    setMeta('name', 'twitter:description', meta.description);
    setMeta('name', 'twitter:image', OG_IMAGE);
  }, [path, meta]);
  return null;
}
